import { _ as _sfc_main } from "./VaAvatarGroup.vue_vue_type_script_lang-68df8853.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeClass, Fragment, renderList, createBlock, mergeProps, renderSlot, normalizeProps, guardReactiveProps, createVNode, withCtx, createTextVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaAvatarGroup_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_avatar = resolveComponent("va-avatar");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-avatar-group", _ctx.classComputed]),
    role: "group"
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.maxOptions, (option, idx) => {
      return openBlock(), createBlock(_component_va_avatar, mergeProps({ key: idx }, { ..._ctx.avatarProps, ...option }, { role: "listitem" }), null, 16);
    }), 128)),
    renderSlot(_ctx.$slots, "rest", normalizeProps(guardReactiveProps(_ctx.avatarProps)), () => [
      createVNode(_component_va_avatar, mergeProps(_ctx.avatarProps, {
        color: _ctx.restColor,
        class: "va-avatar-group__rest",
        role: "listitem"
      }), {
        default: withCtx(() => [
          createTextVNode(" +" + toDisplayString(_ctx.restOptionsCount), 1)
        ]),
        _: 1
      }, 16, ["color"])
    ])
  ], 2);
}
const _VaAvatarGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaAvatarGroup as _
};
//# sourceMappingURL=VaAvatarGroup-904f18af.mjs.map
